<div class="swipeUpWrapper" [class.active]="isActive" >
  <div class="swipeUpWrapper__bg" *ngIf="useBackground" [class.fadeOut]="fadeOut" (click)="toggleShowSwipeUp.emit($event)"></div>
  <app-ds-background-surface
    class="swipeUpWrapper__content {{classType}}"
    [class.active]="isActive"
    [ngStyle]="{ 'max-height': heightVh, 'overflow-y': overflowY }"
    [height]="surfaceHeight"
    [borderRadius]="borderRadius">
    <div class="swipeUpWrapper__content-header" *ngIf="showHeader">
      <app-ds-header
        [widgetConfig]="headerWidgets"
        [isTransparent]="true"
        (clickAction)="toggleShowSwipeUp.emit($event)">
      </app-ds-header>
    </div>
    <div class="swipeUpWrapper__content-body" [class.with-footer]="showFooter" [class.with-header]="showHeader">
      <div class="swipeUpWrapper__content-body-subtitle" *ngIf="showSubTitle">
        <app-ds-typography
          [text]="subTitle"
          [size]="fontSize.XXS"
          [color]="fontColor.Primary">
        </app-ds-typography>
      </div>
      <div class="swipeUpWrapper__content-body-text">
        <ng-content *ngIf="showSwipeUp" select="[content]"></ng-content>
      </div>
    </div>
    <div class="swipeUpWrapper__content-footer" *ngIf="showFooter">
      <ng-content *ngIf="showSwipeUp" select="[footer]"></ng-content>
    </div>
  </app-ds-background-surface>
</div>